import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import { ArrowLeft } from "lucide-react";
import { usePageMeta } from "@/lib/seo";

const renderContent = (content) =>
  content.split("\n\n").map((block, i) => {
    if (block.startsWith("## ")) return <h2 key={i}>{block.slice(3)}</h2>;
    return <p key={i}>{block}</p>;
  });

export default function ArticlePage() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState(false);
  usePageMeta(article?.title || "Article", article?.excerpt);

  useEffect(() => {
    api.get(`/articles/${slug}`).then((r) => setArticle(r.data)).catch(() => setError(true));
  }, [slug]);

  return (
    <main className="bg-[#0b0f19] min-h-screen" data-testid="article-page">
      <Nav />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-24">
        <Link to="/agilite" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-teal-300 transition-colors" data-testid="article-back-link">
          <ArrowLeft size={15} /> Retour aux articles
        </Link>
        {error && <p className="mt-12 text-slate-400">Article introuvable.</p>}
        {article && (
          <article className="mt-10">
            <div className="text-[11px] font-mono2 uppercase tracking-[0.2em] text-blue-400">
              {article.category} · {article.read_time} · {article.author}
            </div>
            <h1 className="mt-4 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-slate-50 leading-tight" data-testid="article-title">
              {article.title}
            </h1>
            {article.image_url && (
              <img src={article.image_url} alt={article.title} className="mt-8 w-full h-64 object-cover opacity-80 border border-white/10" />
            )}
            <div className="mt-8 article-body" data-testid="article-content">
              {renderContent(article.content || "")}
            </div>
            <div className="mt-12 border border-white/10 bg-[#131b2c] p-7">
              <p className="font-heading text-lg font-semibold text-slate-100">Envie d'aller plus loin ?</p>
              <p className="mt-2 text-sm text-slate-400">Échangez avec un expert du partenariat ASAP Technologies × Reqen.</p>
              <Link to="/#contact" className="btn-primary mt-4 inline-flex" data-testid="article-contact-cta">
                Prendre contact
              </Link>
            </div>
          </article>
        )}
      </div>
      <Footer />
    </main>
  );
}
